import { FETCH_SUGGESTED_USERS } from '../constants/actionTypes';

export default (suggestedUsers = [], action) => {
  switch (action.type) {
    case FETCH_SUGGESTED_USERS:
      return action.payload;
    default:
      return suggestedUsers;
  }
}; 